import React, { useEffect, useState } from 'react';
import { api } from '../../../../services/api';
import classNames from '@/utils/className';
import Icon from '@/components/Layout/Icon';
import { mglGray } from '@/styles/designSystemColors';

export default function NewsLetter({
  title = 'Seu resumo inteligente do mundo tech!',
  description = 'Assine a newsletter do Canaltech e receba notícias e reviews sobre tecnologia em primeira mão.',
  inputPlaceHolder = 'Preencha seu e-mail',
  buttonContent = 'inscreva-se',
}) {
  const [email, setEmail] = useState('');
  const [termChecked, setTermChecked] = useState(false);
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [responseText, setResponseText] = useState('');
  const [responseTitle, setResponseTitle] = useState('');
  const [error, setError] = useState<'ResponseError' | 'ValidationError' | 'ValidationTerm' | ''>('');

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (termChecked)
      if (email.match(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g)) {
        api
          .post('/artigo/newsletter/', { email: email })
          .then(response => {
            if (response.status === 200) {
              setResponseTitle('Obrigado por se inscrever!');
              setHasSubmitted(true);
              setTermChecked(false);
              setResponseText(
                'Estamos muito felizes em ter você com a gente!\n' +
                  'Agora você faz parte da nossa comunidade e receberá, em primeira mão, as principais notícias e análises sobre o mundo da tecnologia.\n\n' +
                  'Fique de olho no seu e-mail — tem muita novidade boa chegando por aí!'
              );
              setError('');
            }
          })
          .catch(err => {
            setError('ResponseError');
            setResponseTitle('Ocorreu um erro!');
          });
      } else {
        setError('ValidationError');
      }
    else {
      setError('ValidationTerm');
    }
  };

  useEffect(() => {
    if (error) {
      const timeout = setTimeout(() => setError(''), 3000);
      return () => clearTimeout(timeout);
    }
  }, [error]);

  const getErrorText = () => {
    if (error === 'ValidationError') return 'Por favor, verifique se o e-mail foi digitado corretamente.';
    if (error === 'ResponseError') return 'Não foi possível cadastrar o seu e-mail. Tente novamente.';
    if (error === 'ValidationTerm') return 'Por favor, aceite os termos de uso e política de privacidade.';
    return '';
  };

  return (
    <div className="flex flex-col rounded bg-mglBlue300 p-6 text-mglGray50 mt-4">
      <div className="flex flex-row">
        <div>
        <Icon width={34} height={18.42} icon="mail-send" color={mglGray.mglGray50} className="mr-2 mt-1" />

        </div>
        <span className={classNames('font-lexend font-semibold text-base leading-[130%] align-middle', responseTitle === 'Obrigado por se inscrever!' ? 'mb-0' : 'mb-2 ')}>
          {hasSubmitted ? responseTitle : title}
        </span>
      </div>
      <span className="mb-6 font-lexend font-normal text-[14px] leading-[150%] tracking-[0px] align-middle">{hasSubmitted ? responseText : description}</span>
      <div className="mb-4 flex w-full flex-col">
        <span className={classNames('mb-2 text-xs font-semibold ', error === 'ValidationError' ? 'text-[rgb(255,85,85)]' : 'text-mglGray50')}>
          E-mail
        </span>
        <form className="flex w-full flex-col" onSubmit={e => handleSubmit(e)}>
          <div className="mr-4 flex w-full flex-row items-center rounded bg-mglGray50 p-2">
            <input
              className="h-6 w-full rounded border-none bg-mglGray50 p-2 outline-none font-open-sans font-normal text-xs leading-none tracking-[0%]"
              type="email"
              value={email}
              autoFocus={error === 'ValidationError'}
              onChange={e => setEmail(e.target.value)}
              placeholder={inputPlaceHolder}
            />
          </div>
          <button
            className="border-1 mt-2 w-full rounded  border border-solid border-mglBlue300 bg-mglGray50 p-3 text-mglBlue300  outline-none transition-all duration-300 ease-in-out hover:border-mglGray50 hover:bg-mglBlue300 hover:text-mglGray50"
            type="submit">
            {buttonContent}
          </button>
        </form>
      </div>
      <div className={classNames('mt-4 flex flex-row', error === 'ValidationTerm' ? 'text-[rgb(255,85,85)]' : '')}>
          <input
            type="checkbox"
            checked={termChecked}
            onChange={() => setTermChecked(!termChecked)}
            className="text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600 ml-1 mr-1 h-4 w-4 rounded-sm focus:ring-2"
            id="newsletter-checkbox"
          />
          <label htmlFor="newsletter-checkbox" className="cursor-pointer font-open-sans font-normal text-[12px] leading-[16px] tracking-[0%] align-middle text-mglGray50">
            Confirmo que li, aceito e concordo com os{' '}
            <a href="https://canaltech.com.br/privacidade/" className="text-mglGray50 font-open-sans font-normal text-[12px] leading-[16px] tracking-[0%] align-middle">
              <b>Termos de Uso e Política de Privacidade do Canaltech.</b>
            </a>{' '}
          </label>
        </div>
      {!!error && (
        <span className="mt-2 text-sm text-[rgb(255,85,85)]">
          <b>*** {getErrorText()}</b>
        </span>
      )}
    </div>
  );
}
